import React, { useEffect, useState } from "react";

/**
 * AvatarImage
 * Shows profile_image if available; otherwise renders a circle with the
 * first letter of `name` on a brand-pink background.
 *
 * Props:
 *  - src       : image URL (can be null / undefined / empty string)
 *  - name      : user's display name (used for the fallback initial)
 *  - alt       : img alt text
 *  - style     : inline style object applied to both the <img> and the fallback <div>
 *  - className : CSS class applied to both the <img> and the fallback <div>
 */
function AvatarImage({ src, name, alt, style = {}, className = "" }) {
  const [imgError, setImgError] = useState(false);

  // Reset error state whenever `src` changes (e.g. a new preview image is selected)
  useEffect(() => {
    setImgError(false);
  }, [src]);

  const isDefaultImage =
    typeof src === "string" &&
    (src.includes("configs/default") ||
      src.includes("avatar-placeholder") ||
      src.includes("default_user") ||
      src.includes("user-default") ||
      src.includes("user-profile") ||
      src.includes("User.png") ||
      src.includes("default.png") ||
      src.trim() === "");

  const showFallback = !src || imgError || isDefaultImage;

  const initial =
    name && typeof name === "string" && name.trim().length > 0
      ? name.trim().charAt(0).toUpperCase()
      : "S";

  if (showFallback) {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #FF63B5 0%, #E04899 100%)",
          color: "#fff",
          fontWeight: 700,
          fontSize: style?.fontSize || "22px",
          userSelect: "none",
          flexShrink: 0,
          borderRadius: "50%",
          ...style,
        }}
      >
        {initial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || name || "user"}
      className={className}
      style={style}
      onError={() => setImgError(true)}
    />
  );
}

export default AvatarImage;
